import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-facing-decorator';
import WToggle from "@/components/form/w-toggle.vue";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
let UnlockViewSettings = class UnlockViewSettings extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "lockedSubchapters", void 0);
    _defineProperty(this, "speach", void 0);
    _defineProperty(this, "BASE_API_SPEACHES", '/api/v2/speach');
  }
  async changeLockedSubchapters(value) {
    await axios.put(this.BASE_API_SPEACHES + '/setLockedSubchapters', {
      speachID: this.speachId,
      lockedSubchapters: value
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.speach.speachMetadata.lockedSubchapters = value;
      WElMessage.showSuccessMessage(this.$t("admin.dashboard.speaches.toasts.speachUpdated"));
    }, () => {
      WElMessage.showErrorMessage(this.$t("admin.dashboard.speaches.toasts.speachUpdateFailed"));
    });
  }
};
__decorate([Prop({
  required: true
})], UnlockViewSettings.prototype, "speachId", void 0);
__decorate([Prop({
  default: false
})], UnlockViewSettings.prototype, "lockedSubchapters", void 0);
UnlockViewSettings = __decorate([Component({
  components: {
    WToggle
  }
})], UnlockViewSettings);
export default UnlockViewSettings;